var map = {
	"./Artboard.png": "2vyL",
	"./book.png": "dEzR",
	"./book_1.png": "TP0Q",
	"./book_2.png": "ol7K",
	"./code.png": "8TFO",
	"./code_1.png": "ZabE",
	"./code_2.png": "Wu2e",
	"./conversation.png": "nxwD",
	"./conversation_1.png": "4457",
	"./conversation_2.png": "uj03",
	"./cursor.png": "pHLT",
	"./error.png": "gE8K",
	"./error_1.png": "oN2j",
	"./error_2.png": "Zwdl",
	"./fire.png": "dPCe",
	"./fire_1.png": "4jJq",
	"./fire_2.png": "0E9M",
	"./flag.png": "99ul",
	"./flag_1.png": "DJzx",
	"./flag_2.png": "kJBS",
	"./gutachten.png": "IO1Q",
	"./gutachten_1.png": "ciY6",
	"./gutachten_2.png": "uYll",
	"./handshake.png": "SmMU",
	"./handshake_1.png": "kba4",
	"./handshake_2.png": "Dv/5",
	"./lab.png": "l6xs",
	"./lab_1.png": "GoA+",
	"./lab_2.png": "xTz2",
	"./lightbulb.png": "yABz",
	"./lightbulb_1.png": "YisQ",
	"./lightbulb_2.png": "veVl",
	"./move.png": "xDoK",
	"./note.png": "GlzJ",
	"./note_1.png": "a7uv",
	"./note_2.png": "3txG",
	"./person.png": "hWso",
	"./person_1.png": "BTpn",
	"./person_2.png": "0pwo",
	"./present.png": "BLDV",
	"./present_1.png": "Fb1X",
	"./present_2.png": "zWQd",
	"./quote.png": "1J+S",
	"./quote_1.png": "rFrE",
	"./quote_2.png": "HDJS",
	"./search.png": "9uNU",
	"./search_1.png": "Ak/V",
	"./search_2.png": "BkWO",
	"./statistics.png": "zkt8",
	"./statistics_1.png": "m4Qf",
	"./statistics_2.png": "zZ8o",
	"./target.png": "+NLy",
	"./target_1.png": "sjNX",
	"./target_2.png": "gVUJ",
	"./warning.png": "BWa7",
	"./warning_1.png": "WRfO",
	"./warning_2.png": "2MNz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "V5bU";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons ^\.\/.*\.png$
// module id = V5bU
// module chunks = 1